// apis/uploadFile.js

import axios from "axios";
import { getSessionId } from "../../../../utils/tokenHandlers";

export const uploadFile = async (
  docName: string | Blob,
  image: string | Blob
) => {
  const sessionid = getSessionId();
  const formData = new FormData();

  if (docName) {
    formData.append("name", docName);
  }

  formData.append("type", "binary");
  formData.append("datas", image);

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}api/upload/image`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${sessionid}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    const { data } = response;

    if (data) {
      const { message, data: responseData } = data;
      if (responseData) {
        const { attachement } = responseData;
        localStorage.setItem("attachmentid", attachement);

        // TODO: use the second API here
      }
      if (message === "Success") {
        // handleUploadKYC();
      }
    }

    return data;
  } catch (error) {
    throw error;
  }
};
